// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611051403/js/" + chunkId + "." + {"44":"ed9d7ca6","225":"8507c854","481":"23835be4","486":"e5085710","770":"d9a47bb3"}[chunkId] + ".0.9815526598364175.chunk.js";
};